export default {"src":"/_next/static/media/freeTag.f37d5439.svg","height":106,"width":139,"blurWidth":0,"blurHeight":0};